let Consts =
{
    baseDir: '/v5/dist/',
    defaultErrorScreenData:
            {
                Data:
                    {
                        name: 'Error',
                        textResources: {
                            ContinueButtonText: 'Try again',
                            HeaderText: '',
                            HeaderTitle: '',
                            InstructionText: 'There was an unexpected error',
                            InstructionTitle: 'Something went wrong'
                        },
                        uiSpec: {},
                        values:
                        {
                            RetryUrl: '',
                            CancelUrl: ''
                        }                
                    }
            }    
}

export default Consts;


/** WEBPACK FOOTER **
 ** ./src/Consts.js
 **/